import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CoreService } from 'src/app/core/services/core.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'bs-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.scss']
})
export class ProfilesComponent implements OnInit {

  public form: FormGroup = new FormGroup({});
  public currentTeams = [];
  public currentProfiles = [];
  public loading = true;
  public title = '';

  constructor(
    private route: ActivatedRoute,
    private coreService: CoreService,
    private titleService: Title,
    private metaService: Meta,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((data) => {
      this.currentTeams = data.type.split(',');
      this.getProfileByTeam(this.currentTeams);
    });
  }

  getProfileByTeam(teams: any[]) {
    this.loading = true;
    this.title = [teams.slice(0, -1).join(', '), teams.slice(-1)[0]]
                    .join(teams.length < 2 ? '' : ' & ').replace(/-/g, ' ');

    ['og:image', 'twitter:image'].forEach((x) => this.metaService.updateTag({
      name: x,
      content: 'https://britishshooting.org.uk/compressed-media/4278eff1-4aac-44c7-b98c-35b3f8564312.webp'
    }));
    this.titleService.setTitle(`${this.title.toUpperCase()} Profiles - British Shooting`);
    ['og:title', 'twitter:title'].forEach((x) => this.metaService.updateTag({
      name: x,
      content: `${this.title.toUpperCase()} Profiles - British Shooting`
    }));
    ['description', 'og:description', 'twitter:description'].forEach((x) => this.metaService.updateTag({
      name: x,
      content: `View ${this.title.toLowerCase()} profiles on British Shooting`
    }));

    this.coreService.fetchData('profiles/?limit=1000').pipe(
      map((profiles: any) => {
        const validProfiles = [];

        profiles.forEach((profile) => {
          profile.teams.forEach((team) => {
            if (teams.includes(team.handle)) {
              validProfiles.push(profile);
            }
          });
        });

        return validProfiles.sort((a: any, b: any) => {
          const aval = a.name.split(' ').slice(-1)[0];
          const bval = b.name.split(' ').slice(-1)[0];
          if (aval > bval) {
            return 1;
          }
          return -1;
        });
      })
    ).subscribe((profiles) => {
      this.currentProfiles = profiles;
      this.loading = false;
    });
  }

  getHeaderImage(currentTeams, isMobile = false) {
    currentTeams = currentTeams.map((x) => x.toLowerCase());
    if (currentTeams.includes('our-team')) {
      return isMobile ? '/assets/images/headers/our_team_mobile_2024.webp' : '/assets/images/headers/our_team_2024.webp';
    }
    if (currentTeams.includes('board')) {
      return isMobile ? '/assets/images/headers/board_mobile_2024.webp' : '/assets/images/headers/board_2024.webp';
    }
    if (currentTeams.includes('athletes')) {
      return isMobile ? '/assets/images/headers/athlete_profiles_mobile_2024.webp' : '/assets/images/headers/athlete_profiles_2024.webp';
    }
    if (currentTeams.includes('coaches')) {
      return isMobile ? '/assets/images/headers/coach_profiles_mobile_2024.webp' : '/assets/images/headers/coach_profiles_2024.webp';
    }
    if (currentTeams.includes('lafasttrack')) {
      return '/assets/images/headers/lafasttrack_profiles.webp';
    }
    if (currentTeams.includes('la-fasttrack')) {
      return '/assets/images/headers/lafasttrack_profiles.webp';
    }
    return 'https://britishshooting.org.uk/compressed-media/4278eff1-4aac-44c7-b98c-35b3f8564312.webp';
  }

}
